import '../../helper/scss/utils.scss';

import { isRenderedInIFrame } from 'helper/js/helper';
import useGeneratedDocumentTitle from 'helper/js/hooks/use-generated-title';
import { ReactNode, useEffect } from 'react';
import { useSelector } from 'react-redux';

type DocumentHeadProps = {
  children?: ReactNode;
};

export default function DocumentHead({ children }: DocumentHeadProps) {
  const { locale } = useSelector((state: AppState) => ({
    locale: state.appData.locale,
  }));

  const documentTitle = useGeneratedDocumentTitle();

  useEffect(() => {
    let targetDocument = document;

    try {
      if (isRenderedInIFrame() && window.top?.document) {
        targetDocument = window.top.document;
      }
    } catch {
      targetDocument = document;
    }

    if (targetDocument.title !== documentTitle) {
      targetDocument.title = documentTitle;
    }
  }, [documentTitle]);

  useEffect(() => {
    if (document.documentElement.lang !== locale) {
      document.documentElement.lang = locale;
    }
  }, [locale]);

  return <>{children}</>;
}
